export default __webpack_public_path__ + "static/media/PaqueteCalendario.f353e308.svg";